import type { Mark } from '../types'
import { formatDate, parseKey } from '../lib/date'
import { MARK_LABEL } from '../lib/marks'

const MARK_COLOR: Record<Mark, string> = {
  ok: 'text-ok',
  maybe: 'text-maybe',
  no: 'text-no/60',
}

export interface MyGridEvent {
  id: string
  title: string
}

export interface MyGridRow {
  date: string
  cells: Record<string, Mark | undefined>
}

/** 日程＝行 × イベント＝列。自分の○△×を横断表示（閲覧専用・中立ビュー）*/
export default function MyGrid({ events, rows }: { events: MyGridEvent[]; rows: MyGridRow[] }) {
  const th = 'border-b border-line px-3 py-2.5 font-semibold whitespace-nowrap'
  const td = 'border-b border-line px-3 py-2.5'

  return (
    <div className="scroll-x-hint overflow-x-auto rounded-2xl border border-line bg-surface">
      <table className="min-w-full border-collapse text-sm">
        <thead>
          <tr className="bg-paper/70 text-muted">
            <th className={`sticky left-0 z-10 bg-paper/95 text-left ${th}`}>日程</th>
            {events.map((e) => (
              <th key={e.id} className={`text-center ${th}`}>
                <a href={`/e/${e.id}`} className="font-semibold text-ink transition hover:text-brand">
                  {e.title}
                </a>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.date}>
              <td className={`sticky left-0 z-10 bg-surface font-semibold text-ink whitespace-nowrap ${td}`}>
                {formatDate(parseKey(r.date))}
              </td>
              {events.map((e) => {
                const m = r.cells[e.id]
                return (
                  <td key={e.id} className={`text-center text-lg ${td}`}>
                    <span className={m ? MARK_COLOR[m] : 'text-line'}>
                      {m ? MARK_LABEL[m] : '·'}
                    </span>
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
